import React from "react";
import { useNavigate } from "react-router-dom";
import { NavBarLogin } from "../../components";

const Admin = () => {
  const navigate = useNavigate();

  return (
    <>
      <NavBarLogin />
      <main
        style={{
          padding: 24,
          fontFamily:
            'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial',
        }}
      >
        <header>
          <h1>Admin Dashboard</h1>
          <p style={{ color: "#666" }}>
            Manage site settings, users and content.
          </p>
        </header>

        <section
          style={{
            marginTop: 20,
            display: "grid",
            gap: 12,
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
          }}
        >
          {/* Card: Users */}
          <div
            style={{
              padding: 16,
              border: "1px solid #e6e6e6",
              borderRadius: 8,
            }}
          >
            <h2 style={{ marginTop: 0 }}>Users</h2>
            <p style={{ marginBottom: 12 }}>Activate user, change password and delete users.</p>
            <button onClick={() => navigate("/admin/manage-users")}>
              Manage Users
            </button>
          </div>
          
        </section>
      </main>
    </>
  );
};

export default Admin;
